export default "__VITE_ASSET__BplMmyrB__"